import React, { Component } from 'react';
import { Select, Tag, Button, Space } from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';

export default function Filters({ filters, applyFilters, defaultFilters, onCloseFilterPanel }) {
    const [appliedFilters, setAppliedFilters] = useState(JSON.parse(JSON.stringify(defaultFilters)));

    const HandleFilterChange = (data, key) => {
        console.log([data, key]);
        setAppliedFilters(prev => {
            console.log({ prev });
            prev[key] = data;
            if (data?.length == 0) {
                delete prev[key];
            }
            return prev;
        });
    };

    const HandleApplyFilters = () => {
        applyFilters(appliedFilters);
        onCloseFilterPanel();
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div
                style={{
                    display: 'flex',
                    flexFlow: 'row wrap',
                    gap: 8,
                    maxHeight: '60vh',
                    overflow: 'auto',
                }}
            >
                {Object.keys(filters)?.map(key => {
                    return (
                        <Select
                            key={key}
                            mode="multiple"
                            maxTagCount={0}
                            style={{
                                width: 220,
                            }}
                            placeholder={key}
                            options={filters?.[key]?.map(val => {
                                return {
                                    label: val,
                                    value: val,
                                };
                            })}
                            defaultValue={appliedFilters?.[key]}
                            showSearch
                            allowClear
                            onChange={data => HandleFilterChange(data, key)}
                        />
                    );
                })}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Space>
                    <Button type="primary" onClick={() => HandleApplyFilters()}>
                        Apply
                    </Button>
                    <Button
                        onClick={() => {
                            setAppliedFilters({});
                            applyFilters({});
                            onCloseFilterPanel();
                        }}
                    >
                        Clear
                    </Button>
                </Space>
            </div>
        </div>
    );
}
